function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';
var CSS_CHUNK_LOAD_ERROR_CODE = 'CSS_CHUNK_LOAD_FAILED';
var CHUNK_RETRY_STORAGE_KEY = 'router-chunk-retry-path';

/**
 * 判断当前路由错误是否属于懒加载分包加载失败。
 */
export function isChunkLoadError(error) {
  if (!error) {
    return false;
  }
  var errorMessage = error.message || '';
  return error.name === CHUNK_LOAD_ERROR_NAME || error.code === CSS_CHUNK_LOAD_ERROR_CODE || /Loading chunk/i.test(errorMessage) || /Loading CSS chunk/i.test(errorMessage);
}

/**
 * 创建路由分包加载失败恢复器。
 */
export function createChunkLoadRecovery(_ref) {
  var _ref$storage = _ref.storage,
    storage = _ref$storage === void 0 ? window.sessionStorage : _ref$storage,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? window.location : _ref$location,
    currentRouteGetter = _ref.currentRouteGetter;
  var getRetryTarget = function getRetryTarget() {
    var currentRoute = currentRouteGetter ? currentRouteGetter() : null;
    if (currentRoute && currentRoute.fullPath) {
      return currentRoute.fullPath;
    }
    return location.href;
  };
  return {
    handleError: function handleError(error) {
      if (!isChunkLoadError(error)) {
        return false;
      }
      var retryTarget = getRetryTarget();
      if (storage.getItem(CHUNK_RETRY_STORAGE_KEY) === retryTarget) {
        return false;
      }
      storage.setItem(CHUNK_RETRY_STORAGE_KEY, retryTarget);
      location.replace(retryTarget);
      return true;
    },
    clearRetry: function clearRetry() {
      storage.removeItem(CHUNK_RETRY_STORAGE_KEY);
    }
  };
}

/**
 * 为路由注册分包加载失败的自动恢复逻辑，避免线上首次进入懒加载页面时直接卡死。
 */
export function registerChunkLoadRecovery(router) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var recovery = createChunkLoadRecovery(_objectSpread(_objectSpread({}, options), {}, {
    currentRouteGetter: options.currentRouteGetter || function () {
      return router.currentRoute;
    }
  }));
  router.onError(function (error) {
    var handled = recovery.handleError(error);
    if (!handled) {
      console.error('[router-chunk-recovery] route component load failed', error);
    }
  });
  router.afterEach(function () {
    recovery.clearRetry();
  });
}